module.exports = __webpack_public_path__ + "img/BlinkArt_Staff_Basic.c3d6b1e1.png";